import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import { CitationSourceKind } from "ai-assistant/citations/citation-source-kind";
import type { ComponentType } from "react";

/** The side navigation's icons where it has one: the knowledge base's book, the marketplace's storefront. */
const ICONS: Readonly<Record<CitationSourceKind, ComponentType<SvgIconProps>>> = {
  [CitationSourceKind.File]: InsertDriveFileOutlinedIcon,
  [CitationSourceKind.ForumMessage]: ForumOutlinedIcon,
  [CitationSourceKind.Proposal]: AssignmentOutlinedIcon,
  [CitationSourceKind.WorkAgreement]: HandshakeOutlinedIcon,
  [CitationSourceKind.KnowledgeBaseArticle]: MenuBookOutlinedIcon,
  [CitationSourceKind.MarketplaceProfile]: StorefrontOutlinedIcon,
  [CitationSourceKind.AppPage]: WebOutlinedIcon,
};

/**
 * The icon for what kind of thing a citation quotes (#5986).
 *
 * Decorative: the row says the kind in words beside it, and that text is what a screen reader
 * reads, so the icon is hidden from the accessibility tree rather than named twice.
 */
export default function CitationSourceKindIcon({ kind }: Readonly<{ kind: CitationSourceKind }>) {
  const Icon = ICONS[kind];
  return <Icon aria-hidden data-testid={`citation-kind-icon-${kind}`} fontSize="inherit" sx={{ color: "text.secondary" }} />;
}
